import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { AuthState } from './types';
import { accountQueryApi } from 'features/account/query';

const initialState: AuthState = {
  currentUser: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
  },

  extraReducers: builder => {
    const { GetMe } = accountQueryApi.endpoints;

    builder
      .addMatcher(isAnyOf(GetMe.matchPending, GetMe.matchRejected), () => {})
      .addMatcher(GetMe.matchFulfilled, (state, { payload }) => {
        const { displayName, partnerCode, roleName, userName } =
          payload?.data || {};
        state.currentUser = {
          userRole: roleName,
          displayName,
          partnerCode,
          userName,
        };
      });
  },
});

export const { setCurrentUser } = authSlice.actions;

export default authSlice.reducer;
